var initializeProductBlock = function(block){

	enableProductCarousel(block);
	
	jQuery('.product-categories a.get-products', block).on('click', function(){
		
		block.addClass('loading');
		
		var current = jQuery(this);
		var productCat = current.attr('data-cat');
		
		jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_products_ajax&product-cat='+ productCat,
			success:function(results){
				
				jQuery('.products-container', block).html(results);
				
				var totalProducts = jQuery('.products-container li.product', block).length;
				
				enableProductCarousel(block, totalProducts);
				
				block.removeClass('loading');
				
			}
		});
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-product').each(function(){
		initializeProductBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=product', initializeProductBlock);


function enableProductCarousel(block, totalProducts = 4) {
	
	if(totalProducts > 4) {
		totalProducts = 4;
	}
	
	jQuery('.slick', block).slick({
		slidesToShow: totalProducts,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: false,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		responsive: [
			{
			  breakpoint: 1165,
			  settings: {
				slidesToShow: totalProducts > 3 ? 3 : totalProducts
			  }
			},
			{
			  breakpoint: 785,
			  settings: {
				slidesToShow: totalProducts > 2 ? 2 : totalProducts
			  }
			},
			{
			  breakpoint: 530,
			  settings: {
				slidesToShow: 1
			  }
			}
		]
			
	});
	
}